import styled from 'styled-components';
import { layout } from 'src/components/base';
import { ProductCompactListCard } from 'src/components/product-card-new';

export const ListUl = styled.ul`
  display: grid;
  list-style: none;
  margin-top: ${layout.measurements.spacing050};

  [class^='AdContainer'] {
    padding: ${layout.measurements.spacing050} 0;
  }
`;

export const ProductCard = styled(ProductCompactListCard)<{ $order: number }>`
  order: ${p => p.$order};
`;

export const OfferCard = styled(ProductCompactListCard)<{
  $order: number;
}>`
  order: ${p => p.$order};
`;
